import { Region } from 'evee-ui-common/enums';

import { HEADER_NOTIFICATION_MODES } from './constants';

export const getRegion = (state) => state.app.region;
export const getCurrency = (state) => state.app.currency;
export const getNotificationCounts = (state) => state.app.notificationCounts;
export const getHeaderNotificationMode = (state) => state.app.headerNotification.mode;

export const getHeaderNotification = (state) => {
  const isAustralia = state.app.region?.id === Region.australia.id;
  const { open, mode, dismissed } = state.app.headerNotification;

  if (!isAustralia || !open) {
    return false;
  }

  if (mode === HEADER_NOTIFICATION_MODES.showOnce && dismissed) {
    return false;
  }

  return true;
};

export const getLoading = (state) => state.app.isLoading;
